import { createContext, useContext, ReactNode } from "react";

interface CountryData {
  country: string | null;
  language: string;
  ip: string | null;
  isLoading: boolean;
}

const CountryContext = createContext<CountryData>({
  country: null,
  language: "en",
  ip: null,
  isLoading: false,
});

export const useCountry = () => useContext(CountryContext);

// Country detection disabled to reduce edge function costs.
// Returns static defaults. Re-enable by restoring the detect-country edge function call.
export const CountryProvider = ({ children }: { children: ReactNode }) => {
  const countryData: CountryData = {
    country: null,
    language: "en",
    ip: null,
    isLoading: false,
  };

  return (
    <CountryContext.Provider value={countryData}>
      {children}
    </CountryContext.Provider>
  );
};
